import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { BlockScrollStrategy } from '@angular/cdk/overlay';
import { ConfigurationOptionsEnum } from 'src/app/Enums/ConfigurationOptionsEnum';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationCompanyService {

  private _emitNfce: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(Object.assign({}));
  private setEmitNfce(emitNfce: boolean) { this._emitNfce.next(emitNfce); }
  public getEmitNfce(): Observable<boolean> { return this._emitNfce.asObservable(); }

  constructor(private api: ApiService) {
  }

  async setProductCodeConfiguration(configurationId: number, newConfigurationOptionId: number): Promise<any> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/product-code', { configurationId, newConfigurationOptionId });
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async setProductInventoryConfiguration(configurationId: number, newConfigurationOptionId: number): Promise<any> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/product-inventory', { configurationId, newConfigurationOptionId });
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }
  async setEmitNFCeConfiguration(configurationId: number, newConfigurationOptionId: number): Promise<any> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/emit-nfce', { configurationId, newConfigurationOptionId });
      if (r.success) {
        this.setEmitNfce(newConfigurationOptionId == ConfigurationOptionsEnum.NfceYes ? true : false);
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }
  async setAcceptedPaymentMethodConfiguration(paymentMethod: number, configurationId: number, newConfigurationOptionId: number, selectedQuantityOfInstallments: number = 0): Promise<any> {
    try {
      const valueNumeric = selectedQuantityOfInstallments>0 ? selectedQuantityOfInstallments : null;
      const r = await this.api.put<any>('/v1/configuration-company/accepted-payment-methods-settings', { paymentMethod, configurationId, newConfigurationOptionId, valueNumeric });
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async getSmartPosEcValue(): Promise<string | null> {
    try {
      const r = await this.api.get<any>('/v1/configuration-company/smart-pos-ec');
      if (r.success) {
        if (r.data != null && r.data != undefined) {
          return r.data.ecValue;
        }
        return null;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async setSmartPosEcValue(ecValue: string): Promise<boolean> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/smart-pos-ec', {smartPosEc: ecValue});
      if (r.success) {
        return true;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async updatePriceFormation(priceFormationType: number): Promise<any> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/price-formation', { PriceFormationType: priceFormationType });
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async updateCostPriceCalculation(costPriceCalculationType: number): Promise<any> {
    try {
      const r = await this.api.put<any>('/v1/configuration-company/cost-price-calculation', { ConfigurationOptionId: costPriceCalculationType });
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

}
